import { AdminAnketaEvaluation } from './AdminAnketaEvaluation';

export default AdminAnketaEvaluation;